export default __webpack_public_path__ + "static/media/death_counts_by_sex.a4457697.png";